const routes = [{
  path: '/company-1',
  component: () => import('@/views/company'),
  name: 'company-1',
  meta: {
    title: '自主信息'
  }
}, {
  path: '/company-2',
  component: () => import('@/views/company/official'),
  name: 'company-2',
  meta: {
    title: '官方信息'
  }
}, {
  path: '/atlasDetail',
  component: () => import('@/views/company/atlasDetail'),
  name: 'atlasDetail',
  meta: {
    title: '详情'
  }
}, {
  path: '/admin/company',
  component: () => import('@/views/company/company'),
  name: 'admin-company',
  meta: {
    title: '保司信息维护'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/company.js